export interface NavItem {
  to: string;
  label: string;
  icon: string;
  shortLabel?: string;
  permiso?: string | string[];
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', shortLabel: 'Inicio', icon: '🏠' },
  { to: '/produccion', label: 'Calculadora de produccion', shortLabel: 'Calcular', icon: '🧮', permiso: 'produccion:calcular' },
  { to: '/produccion-del-dia', label: 'Historial de produccion', shortLabel: 'Historial', icon: '📋', permiso: 'lotes:read' },
  { to: '/bitacora', label: 'Bitacora de proceso', shortLabel: 'Bitacora', icon: '📝', permiso: 'bitacora:read' },
  { to: '/ventas', label: 'Ventas reales', shortLabel: 'Ventas', icon: '$', permiso: 'movimientos:read' },
  { to: '/movimientos', label: 'Movimientos', shortLabel: 'Movim.', icon: '💸', permiso: 'movimientos:read' },
  { to: '/compras', label: 'Compras', shortLabel: 'Compras', icon: '🛒', permiso: 'compras:read' },
  { to: '/inventario', label: 'Inventario', shortLabel: 'Invent.', icon: '▦', permiso: 'insumos:read' },
  { to: '/insumos', label: 'Insumos', shortLabel: 'Insumos', icon: '📦', permiso: 'insumos:read' },
  { to: '/inversiones', label: 'Inversiones y equipos', shortLabel: 'Equipos', icon: '🏭', permiso: 'inversiones:read' },
  { to: '/reportes', label: 'Reportes y proyecciones', shortLabel: 'Reportes', icon: '📊', permiso: 'reportes:read' },
  { to: '/punto-equilibrio', label: 'Punto de equilibrio', shortLabel: 'Equilibrio', icon: '⚖️', permiso: 'reportes:read' },
  { to: '/configuracion', label: 'Configuracion', shortLabel: 'Config.', icon: '⚙️', permiso: 'parametros:read' },
  { to: '/admin', label: 'Administracion', shortLabel: 'Admin', icon: '🛠️', permiso: 'usuarios:admin' },
];

export const BOTTOM_NAV_ROUTES = ['/dashboard', '/produccion-del-dia', '/ventas', '/movimientos'] as const;

export function filterByPermisos(items: NavItem[], tiene: (p: string) => boolean): NavItem[] {
  return items.filter((i) => {
    if (!i.permiso) return true;
    const perms = Array.isArray(i.permiso) ? i.permiso : [i.permiso];
    return perms.some((p) => tiene(p));
  });
}
